let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1g0NO")).then(() => parcelRequire('6Q31y'));